const keys = {
  ALERTA_VENCIMENTO_DATA_FATURAMENTO_COMPRA: {
    key: 'ALERTA_VENCIMENTO_DATA_FATURAMENTO_COMPRA',
    description: 'Enviar notificação de alerta ao fornecedor sobre o vencimento do prazo de faturamento da compra.',
    diasLimiteInfo: null,
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: false,
    desativaEdicaoEmail: false,
    desativaEdicaoWhatsapp: true,
    permiteEditarDiasLimite: false,
  },
  ALERTA_ATRASO_COMPRA_FORNECEDOR: {
    key: 'ALERTA_ATRASO_COMPRA_FORNECEDOR',
    description: 'Enviar notificação de alerta ao fornecedor para compras atrasadas (Apenas CIF).',
    diasLimiteInfo: 'Quantidade de dias de atraso para enviar a notificação.',
    defaultEmailEnabledValue: false,
    defaultWhatsappEnabledValue: false,
    desativaEdicaoEmail: false,
    desativaEdicaoWhatsapp: true,
    permiteEditarDiasLimite: true,
  },
  ALERTA_ATRASO_COMPRA_COMPRADOR: {
    key: 'ALERTA_ATRASO_COMPRA_COMPRADOR',
    description: 'Enviar notificação de alerta ao comprador responsável para compras atrasadas.',
    diasLimiteInfo: 'Quantidade de dias de atraso para enviar a notificação.',
    defaultEmailEnabledValue: false,
    defaultWhatsappEnabledValue: false,
    desativaEdicaoEmail: false,
    desativaEdicaoWhatsapp: true,
    permiteEditarDiasLimite: true,
  },
  FINALIZACAO_FORNECEDOR: {
    key: 'FINALIZACAO_FORNECEDOR',
    description: 'Enviar notificação de compra pendente com o fornecedor.',
    diasLimiteInfo: null,
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
    desativaEdicaoEmail: false,
    desativaEdicaoWhatsapp: false,
    permiteEditarDiasLimite: false,
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
